const SECTOR_KEYWORDS = new Set(['G10', 'EM ASIA', 'CEEMEA']);
const RATES_GRID_KEYWORDS = new Set(['RATES']);

const norm = (s) => (s == null ? '' : String(s)).trim().toUpperCase().replace(/\s+/g, ' ');

const canonicalFxPair = (a, b) => {
    if (a === 'USD') return `USD${b}`;
    if (b === 'USD') return `USD${a}`;
    return `${a}${b}`;
};

const pickCurveCcy = (curve) => {
    if (!curve) return null;
    if (typeof curve === 'string') return curve;
    return curve.ccy || curve.currency || curve.name || null;
};

export function parseCtascanArgument(argument, deps = {}) {
    const a = norm(argument);
    if (!a) return { kind: 'grid' };

    const {
        irsCurves = [],
        equityTickers = [],
        fxCurrencies = new Set(),
        sectors
    } = deps;

    const sectorSet = sectors ? new Set(sectors.map(norm)) : SECTOR_KEYWORDS;

    // 1. Rates grid / sector keyword
    if (RATES_GRID_KEYWORDS.has(a)) return { kind: 'rates' };
    if (sectorSet.has(a)) return { kind: 'sector', value: a };

    // 2. IRS curve name (match against curve.name)
    const curveHit = irsCurves.find((c) => norm(c?.name ?? c) === a);
    if (curveHit) {
        const ccy = pickCurveCcy(curveHit);
        return { kind: 'curve', value: ccy };
    }

    // 3. Equity ticker
    const tickerHit = equityTickers.find((t) => norm(t?.displayTicker ?? t) === a);
    if (tickerHit) {
        const tk = tickerHit.displayTicker || tickerHit;
        return { kind: 'ticker', value: typeof tk === 'string' ? tk : String(tk) };
    }

    // 4. FX — pair (either ordering) or single CCY
    if (a.length === 6) {
        const a1 = a.slice(0, 3);
        const a2 = a.slice(3);
        if (fxCurrencies.has(a1) && fxCurrencies.has(a2)) {
            return { kind: 'fxpair', value: canonicalFxPair(a1, a2) };
        }
    }
    if (a.length === 3 && fxCurrencies.has(a)) {
        return { kind: 'fxpair', value: canonicalFxPair('USD', a) };
    }

    // 5. Fallback
    return { kind: 'grid' };
}

export function resolveCtascanUrl(parsed, opts = {}) {
    const uiBase = opts.uiBase ?? '';
    const u = (path) => `${uiBase}${path}`;
    switch (parsed?.kind) {
        case 'rates':  return u('cta?tab=rates');
        case 'sector': return u(`cta?tab=rates&sector=${encodeURIComponent(parsed.value)}`);
        case 'curve':  return u(`cta?tab=rates&ccy=${encodeURIComponent(parsed.value)}`);
        case 'ticker': return u(`cta?tab=equities&ticker=${encodeURIComponent(parsed.value)}`);
        case 'fxpair': return u(`cta?tab=forex&pair=${encodeURIComponent(parsed.value)}`);
        case 'grid':
        default:       return u('cta');
    }
}
